export default function getPackageKeyFromPathname(pathname, itineraryId) {
	let requestUrl = pathname
	console.log({ requestUrl })
	const urlArr = requestUrl.split('/')
	if (urlArr[1] && urlArr[1].length === 2) {
		requestUrl = requestUrl.replace('/' + urlArr[1], '')
	}

	let key = requestUrl
	if (itineraryId) {
		key = key.replace(itineraryId + '/', '')
	}

	// Remove the first slash ("/") from the pathname - which always be part of the pathname
	if (key.charAt(0) === '/') {
		key = key.substr(1)
	}

	// Remove the search query from the pathname
	key = key.split('?')[0]

	let removeOtherRoutes = [
		'get-cost',
		'request-callback',
		'login',
		'signup',
		'costing-delay',
		'inclusions',
		'icc-t20-cbr',
		'request-callback-smm',
		'image-gallery',
		'deals-image-gallery',
		'room-upgrade',
		'faq',
		'details',
	]

	// Split the pathname into parts to loop through and remove modal URLs
	let pArr = key.split('/')
	removeOtherRoutes.map(v => {
		if (pArr.indexOf(v) !== -1) {
			pArr = pArr.splice(0, pArr.indexOf(v))

			key = pArr.join('/')
		}
		return false
	})

	return key
}
